import React from 'react';
import Constants from './../constants/Constants';
import bubble from '../../media/images/icons/bubble-left.png';
import Pile from './piles/Pile';

class GEntity {
    constructor(gameCtx, entityIndex, args) {
        this.gameCtx = gameCtx;
        this.entityIndex = entityIndex;
        this.args = args;
        this.cards = [];
        this.firstCardCoords = [0, 0];
        this.lastReceivedCards = [];

        this.enableResolvePlayerFinal = true;
        this.userEventComplete = this.defer();

        this.setScreenDimensions();
        this.setInitialCoords();

        this.cardSideShown = false; // TODO: false
    }

    shuffleCardsArr = (cards) => {
        let shuffledCards = [...cards];

        for (let i = shuffledCards.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffledCards[i], shuffledCards[j]] = [shuffledCards[j], shuffledCards[i]];
        }

        return shuffledCards;
    }

    shuffleDealing = () => {
        let cards = this.cards;
        let shuffledCards = [...cards];

        for (let i = shuffledCards.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffledCards[i].firstOwner, shuffledCards[j].firstOwner] = [shuffledCards[j].firstOwner, shuffledCards[i].firstOwner];
        }

        shuffledCards.sort((a, b) => a.firstOwner - b.firstOwner);
        this.setCards(shuffledCards);
    }

    dealCards = async () => {
        let cards = this.getCards();
        cards.sort((a, b) => a.firstOwner - b.firstOwner);

        for (let i = 0; i < Constants.CARDS_TO_DEAL; i++) {
            let card = this.getLastCard();
            await this.gameCtx.moveCard(this.entityIndex, card.firstOwner, card, false, false, false);
            await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE);
        }
    }

    dealCardsSimulation = () => {
        let cards = this.getCards();
        cards.sort((a, b) => a.firstOwner - b.firstOwner);

        for (let i = 0; i < Constants.CARDS_TO_DEAL; i++) {
            let card = this.getLastCard();
            this.gameCtx.moveCardSimulation(this.entityIndex, card.firstOwner, card);
        }
    }

    getCardsHeight = () => {
        return this.getCardsWidth() * 1.5;
    }

    getCardsWidth = () => {
        if (this.sWidth > 1300) {
            return Constants.CARD_WIDTH_DESKTOP;
        }

        if (this.sWidth > 600) {
            return Constants.CARD_WIDTH_TABLET;
        }

        if (this.sWidth > 0) {
            return Constants.CARD_WIDTH_MOBILE;
        }
    }

    getLeftPosForHorizontalLayout = () => {
        let maxCards = Constants.MAX_CARD_FOR_EACH_PLAYER;
        let cardWidth = this.getCardsWidth();
        this.spaceBetweenCards = 0;
        let left = (this.sWidth - (maxCards * (cardWidth + this.spaceBetweenCards))) / 2;
        return left;
    }

    getTopPosForVerticalLayout = () => {
        let maxCards = Constants.MAX_CARD_FOR_EACH_PLAYER;
        let cardWidth = this.getCardsWidth();
        this.spaceBetweenCards = 0;
        let top = (this.sHeight - (maxCards * (cardWidth + this.spaceBetweenCards))) / 2;
        return top + 40;
    }

    addCard = (card) => {
        card.owner = this.entityIndex;
        this.cards.push(card);
    }

    removeCard = (card) => {
        for (let i = this.cards.length - 1; i >= 0; i--) {
            if (this.cards[i].comp.key === card.comp.key) {
                return this.cards.splice(i, 1);
            }
        }
        console.log("ERROR: card canno't be removed from array")
    }

    setScreenDimensions = () => {
        let w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;

        this.sWidth = x;
        this.sHeight = y;
    }

    // Set the initial coordinations for the first card on screen relative to max cards for this entity
    getInitialCoords = () => {
        return this.firstCardCoords;
    }

    getCoordsForNewCard = () => {
        return [this.firstCardCoords[0] + (10 * this.cards.length), this.firstCardCoords[1] - (100)];
    }

    getCards = () => {
        return this.cards;
    }

    setCards = (cards) => {
        this.cards = cards;
    }

    degreesToRadians = (deg) => {
        return deg * (Math.PI / 180)
    }

    getLastCard = () => {
        let cards = this.getCards();
        if (cards.length === 0) { return null };
        return cards[cards.length - 1];
    }

    defer = () => {
        var res, rej;
        var promise = new Promise((resolve, reject) => {
            res = resolve; rej = reject;
        }).then(() => { promise.isDone = true; });

        promise.isDone = false;
        promise.resolve = res;
        promise.reject = rej;
        return promise;
    }

    //TODO: unite with others
    setPopupEvent = () => {
        let res, rej;
        let promise = new Promise((resolve, reject) => {
            res = resolve; rej = reject;
        });
        promise.isDone = false;
        promise.resolve = res;
        promise.reject = rej;
        this.popupEvent = promise;
    }

    resolvePopupEvent = (val) => {
        this.popupEvent.resolve(val);
        this.popupEvent.isDone = true;
    }

    setUserEvent = () => {
        this.userEvent = this.defer(); //promise
    }

    setFinalUserEvent = () => {
        this.userEventComplete = this.defer(); //promise
    }

    resolvePlayer = () => {
        this.userEvent.resolve();
    }

    resolvePlayerFinal = () => {
        if (this.enableResolvePlayerFinal) {
            this.userEventComplete.resolve();
        }
    }

    unsubscribeEventToCards = () => {
        let cards = this.getCards();
            cards.forEach((card) => {
                card.ref.current.setOnClick(null);
            });
    }

    unsubscribeEventToCard = (cardObj) => {
        cardObj.ref.current.setOnClick(null);
    }

    subscribeUserEventToCard = (cardObj, event, singleTimeUse = false) => {
        if (cardObj === null || cardObj === undefined) return;
        this.setUserEvent();
        cardObj.ref.current.setOnClick(event, singleTimeUse);
    }

    subscribeUserEventToCards = (event, singleTimeUse = false) => {
        this.setUserEvent();
        let cards = this.getCards();

        cards.forEach((card) => {
            card.ref.current.setOnClick(event, singleTimeUse);
        })
    }

    waitForEvent = async () => {
        return this.userEvent;
    }

    reArrangeCards = async () => {
        this.cards.forEach((card, i) => {
            let [left, top, rotDeg, cardSideShown, layer] = this.getCardCoordsByIndex(card, i);
            card.ref.current.changePos(left, top, rotDeg, this.cardSideShown, false, 0.1, layer);
        });
    }

    getName = () => {
        return this.args.name;
    }

    setInitialCoords = () => {
        switch (this.args.posMethod) {
            case Constants.METHOD_PERCENTAGE:
                let x = (this.args.left * 0.01) * this.sWidth;
                let y = (this.args.top * 0.01) * this.sHeight;
                this.firstCardCoords = [x, y];
                break;

            default: return
        }
    }

    resetInitialCoords = () => {
        // resetInitialCoords GEntity
    }

    resetCards = async () => {
        let cards = [...this.getCards()];
        await this.throwMyCardsToUsedPile();
        await this.getCardsFromNewPile(cards.length);
        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL)
    }

    getLastReceivedCards = () => {
        return this.lastReceivedCards;
    }

    getCardsFromNewPile = async (cardsNum) => {
        let newPile = this.gameCtx.entitiesRepo.getNewPile();
        let newPileCard = null;

        for (let i = 0; i < cardsNum; i++) {
            newPileCard = newPile.getLastCard();
            await this.gameCtx.moveCard(Constants.NEW_PILE_INDEX, this.entityIndex, newPileCard, true, true, cardsNum === 1);
        }
    }

    getCardsFromCandyPile = async (cardsNum) => {
        let candyPile = this.gameCtx.entitiesRepo.getCandyPile();
        let candyPileCard = null;

        for (let i = 0; i < cardsNum; i++) {
            candyPileCard = candyPile.getLastCard();
            await this.gameCtx.moveCard(Constants.CANDY_PILE_INDEX, this.entityIndex, candyPileCard, true, true, cardsNum === 1);
        }
    }

    throwMyCardsToUsedPile = async () => {//Only virus?
        let cards = this.getCards();
        let usedPileIndex = Constants.USED_PILE_INDEX;
        await this.gameCtx.moveCards(this.entityIndex, usedPileIndex, cards, true, false);
        await this.gameCtx.waitFor(Constants.INTERVAL_AFTER_MYPLAYER_PLAY);
    }

    getBubbleHeight = () => {
        if (this.sWidth > 1300) {
            return Constants.BUBBLE_HEIGHT_DESKTOP;
        }

        if (this.sWidth > 600) {
            return Constants.BUBBLE_HEIGHT_TABLET;
        }

        if (this.sWidth > 0) {
            return Constants.BUBBLE_HEIGHT_MOBILE;
        }
    }

    addBubbleAccordingToPosition = (text, key, bubblePosition, textPosition) => {
        const RATIO_BETWEEN_BUBBLE_HEIGHT_AND_TEXT = 0.10;
        const RATIO_BETWEEN_BUBBLE_HEIGHT_AND_BUBBLE_WIDTH = 1.18;
        const BUBBLE_HEIGHT = this.getBubbleHeight();
        let shouldAdd = key === 6 ? 0 : 0.5
        const ScreenOrientation=window.innerHeight > window.innerWidth?'portrait':'landscape';

        let bubbleStyle = {
            position: 'absolute',
            top: bubblePosition.top,
            bottom: bubblePosition.bottom,
            left: bubblePosition.left,
            height: `${BUBBLE_HEIGHT}vh`,
            zIndex: 182
        };

        let bubbleTextStyle = {
            fontSize: `${BUBBLE_HEIGHT * RATIO_BETWEEN_BUBBLE_HEIGHT_AND_TEXT + shouldAdd}vh`,
            position: 'absolute',
            top: bubblePosition.top,
            bottom: bubblePosition.bottom,
            left: textPosition.left,
            height: `${BUBBLE_HEIGHT}vh`,
            width: `${BUBBLE_HEIGHT / RATIO_BETWEEN_BUBBLE_HEIGHT_AND_BUBBLE_WIDTH}vh`,
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            zIndex: 182,
            paddingTop:`${ScreenOrientation==='portrait'?`${0.2*BUBBLE_HEIGHT}vh`:'6.3vh'}`,
            paddingBottom:`${ScreenOrientation==='portrait'?`${0.28*BUBBLE_HEIGHT}vh`:'6.3vh'}`,
            margin:0
        }

        const myPlayerBottomBubble =
            <div key={key} className="">
                <img draggable="false" src={bubble} alt="explain_buble" className="bubble" style={bubbleStyle} />
                <p className="bubble-text" style={bubbleTextStyle}>
                    {text}
                </p>
            </div>;
        this.gameCtx.elementsHandler.addElement(key, myPlayerBottomBubble);
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_BUBBLE);
    }

    addBubbleOnPile = (text, key, pile) => {
        const BUBBLE_HEIGHT = this.getBubbleHeight();
        const MAKE_BUBBLE_CLOSER_TO_TOP_EDGE_OF_CARD = 3;
        const MAKE_BUBBLE_CLOSER_TO_RIGHT_EDGE_OF_CARD = 35;
        const MAKE_TEXT_CENTER_OF_BUBBLE = 0.01;

        if (!(pile instanceof Pile)) { return }

        let [left, top] = pile.firstCardCoords;
        let topBubble = top - ((BUBBLE_HEIGHT - MAKE_BUBBLE_CLOSER_TO_TOP_EDGE_OF_CARD) / 100) * this.sHeight;
        let topText = topBubble - MAKE_TEXT_CENTER_OF_BUBBLE * this.sHeight; //px
        let leftBubble = left + this.getCardsWidth() - MAKE_BUBBLE_CLOSER_TO_RIGHT_EDGE_OF_CARD; //px

        let bubblePosition = {
            top: `${topBubble}px`,
            bottom: 'auto',
            left: `${leftBubble}px`,
        };

        let textPosition = {
            top: `${topText}px`,
            bottom: 'auto',
            left: `${leftBubble}px`,
        };

        this.addBubbleAccordingToPosition(text, key, bubblePosition, textPosition);
    }
}

export default GEntity;
